"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontSize;
(function (FontSize) {
    FontSize["Zero"] = "u-zero";
    FontSize["Micro"] = "u-micro";
    FontSize["Milli"] = "u-milli";
    FontSize["Alpha"] = "u-alpha";
    FontSize["Beta"] = "u-beta";
    FontSize["Gamma"] = "u-gamma";
    FontSize["Delta"] = "u-delta";
})(FontSize = exports.FontSize || (exports.FontSize = {}));
var FontSizeSSMediumUp;
(function (FontSizeSSMediumUp) {
    FontSizeSSMediumUp["Zero"] = "u-zero@m";
    FontSizeSSMediumUp["Micro"] = "u-micro@m";
    FontSizeSSMediumUp["Milli"] = "u-milli@m";
    FontSizeSSMediumUp["Alpha"] = "u-alpha@m";
    FontSizeSSMediumUp["Beta"] = "u-beta@m";
    FontSizeSSMediumUp["Gamma"] = "u-gamma@m";
    FontSizeSSMediumUp["Delta"] = "u-delta@m";
})(FontSizeSSMediumUp = exports.FontSizeSSMediumUp || (exports.FontSizeSSMediumUp = {}));
var FontSizeImportant;
(function (FontSizeImportant) {
    FontSizeImportant["Alpha"] = "u-alpha!";
    FontSizeImportant["Beta"] = "u-beta!";
    FontSizeImportant["Gamma"] = "u-gamma!";
    FontSizeImportant["Delta"] = "u-delta!";
})(FontSizeImportant = exports.FontSizeImportant || (exports.FontSizeImportant = {}));
//# sourceMappingURL=FontSize.js.map